import * as angular from 'angular';

export const httpConfig = [
    '$httpProvider',
    ($httpProvider: angular.IHttpProvider) => {
        $httpProvider.interceptors.push('authenticationInterceptorService');
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.defaults.cache = false;
        (<any>$httpProvider.defaults).headers['delete'] = { 'Content-Type': 'application/json;charset=utf-8' }; //TODO: USELESS??
    }
];